import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Language } from '@algoan/dashboard/model';
import { useLanguage } from '@algoan/dashboard/utils';

export const FooterMessage: React.FC = () => {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();

  const redirectToPrivacyPolicy =
    language === Language.FR
      ? 'https://www.algoan.com/fr/politique-de-confidentialite/'
      : 'https://www.algoan.com/data-privacy-policy/';

  const redirectToLegalNotice =
    language === Language.FR ? 'https://www.algoan.com/fr/mentions-legales/' : 'https://www.algoan.com/legal-notice/';

  return (
    <S.MessageContainer>
      <FormattedMessage
        id="footer.copyright"
        description="Algoan's copyright"
        defaultMessage="©{currentYear} Algoan - {legalNotice} - {privacyPolicy}"
        values={{
          currentYear: currentYear,
          legalNotice: (
            <a href={redirectToLegalNotice} target="_blank" rel="noreferrer">
              <FormattedMessage
                id="footer.legal_notice"
                description="Algoan's copyright"
                defaultMessage="Legal notice"
              />
            </a>
          ),
          privacyPolicy: (
            <a href={redirectToPrivacyPolicy} target="_blank" rel="noreferrer">
              <FormattedMessage
                id="footer.privacy_policy"
                description="Algoan's copyright"
                defaultMessage="Data Privacy Policy"
              />
            </a>
          ),
        }}
      />
    </S.MessageContainer>
  );
};

export interface FooterProps {
  color?: string;
}

export const Footer: React.FC<FooterProps> = ({ color }) => {
  return (
    <S.Container backgroundColor={color}>
      <FooterMessage />
    </S.Container>
  );
};

const S = {
  Container: styled.div<{ backgroundColor?: string }>`
    background: ${(props) => props.backgroundColor ?? props.theme.iceBlue};
    width: 100%;
    position: absolute;
    right: 0;
    bottom: 0;

    @media print {
      display: none;
    }
  `,
  MessageContainer: styled.div`
    width: 100%;
    height: 25px;
    text-align: center;
    color: ${(props) => props.theme.secondary.softBlue2};
    font-size: 10px;
    font-weight: normal;
    line-height: 25px;
    margin: 0 auto;
    a:link,
    a:visited {
      text-decoration: none;
      color: ${(props) => props.theme.secondary.softBlue2};
    }
    a:hover {
      text-decoration: underline;
    }
  `,
};
